import { render, staticRenderFns } from "./SubEmpresaBlocoResumoElegibilidade.vue?vue&type=template&id=8240026e&scoped=true&lang=pug"
import script from "./SubEmpresaBlocoResumoElegibilidade.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoResumoElegibilidade.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoResumoElegibilidade.vue?vue&type=style&index=0&id=8240026e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8240026e",
  null
  
)

export default component.exports